module.exports = __webpack_public_path__ + "MapStore2/web/client/components/background/img/default.jpg";